var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnregisterUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.513 58.8317C83.3997 58.8317 93.8464 48.385 93.8464 35.4984C93.8464 22.6117 83.3997 12.165 70.513 12.165C57.6264 12.165 47.1797 22.6117 47.1797 35.4984C47.1797 48.385 57.6264 58.8317 70.513 58.8317Z",
    stroke: "#495057",
    strokeWidth: 8.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0104 78.2378C82.2659 76.9548 76.3964 76.315 70.5104 76.3303C44.7387 76.3303 23.8438 88.0845 23.8438 102.58C23.8438 117.076 23.8438 128.83 70.5104 128.83C103.685 128.83 113.275 122.892 116.051 114.247",
    stroke: "#495057",
    strokeWidth: 8.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.513 117.167C118.4 117.167 128.846 106.72 128.846 93.8333C128.846 80.9467 118.4 70.5 105.513 70.5C92.6264 70.5 82.1797 80.9467 82.1797 93.8333C82.1797 106.72 92.6264 117.167 105.513 117.167Z",
    stroke: "#7663EB",
    strokeWidth: 8.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6797 93.8301H111.346",
    stroke: "#7663EB",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnregisterUser);
export default __webpack_public_path__ + "static/media/unregister-user.84a2e9bbf3928888332959b9a7ba3997.svg";
export { ForwardRef as ReactComponent };